import { ADD_ENTITIES } from "../actions/actions";
import { mergeEntitiesWithState, price } from "../helpers/schema";

const schema = price;

export function prices(
  state = {
    all: {},
  },
  action
) {
  switch (action.type) {
    case ADD_ENTITIES:
      let data = action.payload.price;
      if (!data) return state;

      return {
        ...state,
        all: mergeEntitiesWithState(data, state.all, schema),
      };
    default:
      return state;
  }
}
